var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true)?_c('div',{staticClass:"cart__header"},[_c('backlink'),_vm._v(" "),_vm._m(0)],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart__header-title-container"},[_c('img',{attrs:{"src":"/static/img/pictos/produit-favoris.svg"}}),_vm._v(" "),_c('span',[_vm._v("Mes favoris")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2939567c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product/FavoritesHeader.vue
// module id = 564
// module chunks = 0